import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="subscription-payment"
export default class extends Controller {
  static targets = ["tab", "form", "methodInput", "confirmText"]

  static values = {
    selected: { type: String, default: "flouci" }
  }

  connect() {
    this.updateUI()
  }

  select(event) {
    event.preventDefault()
    const type = event.currentTarget.dataset.type
    this.selectedValue = type
    this.updateUI()
  }

  updateUI() {
    const type = this.selectedValue

    // Update tabs
    this.tabTargets.forEach(tab => {
      if (tab.dataset.type === type) {
        tab.classList.add("border-blue-500", "bg-blue-50", "text-blue-700")
        tab.classList.remove("border-gray-200", "text-gray-600")
      } else {
        tab.classList.remove("border-blue-500", "bg-blue-50", "text-blue-700")
        tab.classList.add("border-gray-200", "text-gray-600")
      }
    })

    // Update forms
    this.formTargets.forEach(form => {
      if (form.dataset.type === type) {
        form.classList.remove("hidden")
      } else {
        form.classList.add("hidden")
      }
    })

    // Update hidden input
    if (this.hasMethodInputTarget) {
      this.methodInputTarget.value = type
    }

    // Update confirmation text
    if (this.hasConfirmTextTarget) {
      const messages = {
        flouci: "🔒 Vous serez redirigé vers la page sécurisée de votre banque pour payer par carte.",
        d17: "📲 Après soumission, votre abonnement sera activé sous 1-2h après vérification du paiement D17.",
        bank_transfer: "🏦 Après soumission, votre abonnement sera activé sous 48h jours ouvrés après réception du virement."
      }
      this.confirmTextTarget.textContent = messages[type] || messages.flouci
    }
  }

  copyToClipboard(event) {
    event.preventDefault()
    const text = event.currentTarget.dataset.text
    const button = event.currentTarget

    navigator.clipboard.writeText(text).then(() => {
      const originalText = button.textContent
      button.textContent = "✓ Copié!"
      button.classList.add("bg-green-500")
      setTimeout(() => {
        button.textContent = originalText
        button.classList.remove("bg-green-500")
      }, 2000)
    })
  }
}
